// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import Typography from "@mui/material/Typography";

// Images
//import logoCT from "assets/images/logo-ct-dark.png";
import logoNux from "../../assets/images/nuxway-isotipo.png";
import pulpito from "../../assets/images/pulpo1.png";

const date = new Date().getFullYear();

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  pulpito: {
    name: "Pulpo",
    image: pulpito,
    route: "/",
  },
  brand: {
    name: "Nuxway Technology",
    image: logoNux,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/nuxway",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/Nuxway",
    },
    {
      icon: <LinkedInIcon />,
      link: "https://www.linkedin.com/company/nuxway-technology/",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/channel/UCy867DMqLULPD9f2FszBzhw",
    },
  ],
  menus: [
    {
      name: "Company",
      items: [
        { name: "About Us", href: "https://www.nuxway.net/" },
        {
          name: "Products and Services",
          href: "https://www.nuxway.net/copia-de-inicio",
        },
        { 
          name: "Blog", 
          href: "https://www.nuxway.net/servicios" 
        },
        {
          name: "Contact Us",
          href: "https://www.nuxway.net/contacto",
        },
        {
          name: "Web Summit Participation",
          href: "https://rio.websummit.com/appearances/rio25/63c8c82b-a855-44e7-bf30-0a54ebb39e0b/nuxway.services",
        },
      ],
    },
  ],
  copyright: (
    <Typography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date}.
    </Typography>
  ),
};
